import { AppsEngineException } from './AppsEngineException';

/**
 * This exception informs the host system that an
 * app has determined that an invalid setting value
 * is passed.
 */
export class InvalidSettingValueException extends AppsEngineException {}
